import React from "react";

import { Box, Grid } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { times } from "lodash";

const AreaDiscountsSkeleton = () => (
  <Box paddingTop={1} paddingRight={2} paddingBottom={1} paddingLeft={2}>
    {times(3, idx => (
      <Grid key={idx} container spacing={2}>
        <Grid item xs={2} sm={1}>
          <Skeleton width="30px" height="40px" />
        </Grid>
        <Grid item xs>
          <Skeleton width="80%" height="40px" />
        </Grid>
        <Grid item xs>
          <Skeleton width="50%" height="40px" />
        </Grid>
        <Grid item xs>
          <Skeleton width="50%" height="40px" />
        </Grid>
        <Grid item xs>
          <Skeleton width="100%" height="40px" />
        </Grid>
      </Grid>
    ))}
  </Box>
);

export default AreaDiscountsSkeleton;
